import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

// labels
import {FL_LONG_DESCRIPTION, FL_SHORT_DESCRIPTION} from "../../../components/i18n/formLabels";
import {PH_LONG_DESCRIPTION, PH_SHORT_DESCRIPTION} from "../../../components/i18n/placeHolders";

const AmenityLang = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            description : '',
            shortDescription  : '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_SHORT_DESCRIPTION}
                        placeholder={PH_SHORT_DESCRIPTION}
                        type="textarea"
                        name="shortDescription"
                        rows={'3'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_LONG_DESCRIPTION}
                        placeholder={PH_LONG_DESCRIPTION}
                        type="textarea"
                        name="description"
                        rows={'5'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default AmenityLang